import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
} from "reactstrap";
// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import { convertToLowestUnit, ExportAvailableInCSVForReports, formatUnitsForReport } from "../../../../helpers/units"
import showNotification from "../../../../helpers/show_notification";
import printDiv from "../../../../helpers/print_data";
import AddOpeningComp from "../../Branch/Items/AddOpeningComp";
import preloader from "../../../../helpers/preloader";
import ExpiryChangePopup from "../../../../components/ExpiryChangeModal";

const ViewInventory = (props) => {
  const { SearchBar } = Search;
  const is_manual_entry_allowed = localStorage.getItem("is_manual_entry_allowed") == "true";

  useEffect(() => {
    loadItems();
  }, []);
  const store_id = localStorage.getItem("store_id")

  const [allItems, setAllItems] = useState([]);
  const loadItems = async () => {
    try {
      preloader(true)
      let url = process.env.REACT_APP_BASEURL + "branchitems/get_sub_store_items";
    const response = await postSubmitForm(url, { sub_store_id: store_id });
    if (response && response.status === 1) {
      preloader(false)
      let filtered = response.data.map(obj => ({
        ...obj,
        label: obj.name,
        value: obj.item_id
      }))
      setAllItems(filtered);
    } else {
      preloader(false)
      showNotification(response.message, "Error");
    }
    } catch (error) {
      preloader(false)
      showNotification(error.message, "Error");
    }
  };



  const [transactionsModal, setTransactionsModal] = useState();
  const [selectedItem, setSelectedItem] = useState();
  const [selectedItem_Transactions, setSelectedItem_Transactions] = useState(
    []
  );
  const handleViewDetailsClick = async (row) => {
    let url = process.env.REACT_APP_BASEURL + "storeiteminventories/get_by_item_id";
    const response = await postSubmitForm(url, { item_id: row.item_id });
    if (response && response.status === 1) {
      setSelectedItem_Transactions(response.data);
      setSelectedItem(row);

      setTransactionsModal(true);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [selectedItemToAdd, setSelectedItemToAdd] = useState();
  const [addInventoryModal, setAddInventoryModal] = useState(false);
  function editFormatter(cell, row) {
    return (
      <>
        <span className="text-info mr-2">
          <i
            className="mdi mdi-text-box-search font-size-15"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              handleViewDetailsClick(row);
            }}
          ></i>
        </span>
        <span style={{ display: is_manual_entry_allowed ? 'inline' : 'none' }}>
          <i
            className="mdi mdi-cart-plus font-size-15"
            title="Add Opening Inventory"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setSelectedItemToAdd(row);
              setAddInventoryModal(!addInventoryModal);
            }}
          ></i>
        </span>
      </>
    );
  }


  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "3%" };
      },
    },
    {
      text: props.t("Name"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    {
      dataField: "category",
      text: props.t("Category"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "threshold",
      text: props.t("Threshold"),
      formatter: (cell, row) => {
        return (
          row.threshold + " " + row.unit_for_threshold
        )
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "available",
      text: props.t("Available"),
      sort: true,
      formatter: (cell, row) => {
        let threshold = convertToLowestUnit(row?.unit_levels, [{ unit: row?.unit_for_threshold, value: row?.threshold }]);
        let totalAvailable = convertToLowestUnit(row?.unit_levels, row?.available)

        if (totalAvailable <= threshold) {
          return (
            <span
              style={{
                whiteSpace: "normal",
                display: "inline-block",
                maxWidth: "100%",
              }}
              className="font-size-12 badge-soft-danger badge badge-danger badge-pill mr-1 mb-1"
            >
              {formatUnitsForReport(row?.available, row?.unit_levels)}
            </span>
          );
        } else {
          return formatUnitsForReport(row.available, row?.unit_levels);
        }

      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },


    {
      text: props.t("Action"),
      formatter: editFormatter,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
    },
  ];


  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );

  const [dateChangeModal, setDateChangeModal] = useState(false);
  const [selectedRowForDateChange, setSelectedRowForDateChange] = useState(null);
  const handleExpiryDateChange = async (newDate) => {
    try {
      if (!newDate) {
        showNotification("Please select a valid date", "Warning");
        return;
      }
      preloader(true);
      const url =
        process.env.REACT_APP_BASEURL +
        "storeiteminventories/update_expiry_date";
      const payload = {
        id: selectedRowForDateChange._id,
        batch: selectedRowForDateChange.batch,
        expiry_date: moment(newDate).format("YYYY-MM-DD"),
      };
      const response = await postSubmitForm(url, payload);
      if (response && response.status === 1) {
        showNotification("Expiry date updated successfully", "Success");
        handleViewDetailsClick(selectedItem);
        setDateChangeModal(false);
        setSelectedRowForDateChange(null);
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification("Error updating expiry date", "Error");
    } finally {
      preloader(false);
    }
  };

  const columns_transaction = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      text: props.t("Batch"),
      dataField: "batch",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Supplier"),
      dataField: "supplier_details.name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "quantity",
      text: props.t("Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity)
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },

    {
      dataField: "cost_price",
      text: props.t("Cost Price"),
      formatter: (cell, row) => {
        return row.cost_price + "/" + row.item_details.unit_for_po
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "selling_price",
      text: props.t("Selling Price"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "remarks",
      text: props.t("Remarks"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      text: props.t("Expiry Date"),
      sort: false,
      formatter: (cell, row) => {
        if (row.expiry_date) {
          return moment(row.expiry_date).format("DD/MM/YYYY HH:mm");
        } else {
          return (
            <>
              <span className="text-info d-flex align-items-center justify-content-center"
                style={{cursor:"pointer"}}
                onClick={() => {
                  setSelectedRowForDateChange(row);
                  setDateChangeModal(true);
                }}
              >
                <i className="bx bxs-edit font-size-15" />
              </span>
            </>
          );
        }
      },
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
    },
    {
      dataField: "",
      text: props.t("Entry Date"),
      sort: false,
      formatter: (cell, row) => {
        return moment(row.createdAt).format("DD/MM/YYYY HH:mm");
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    // {
    //   text: props.t("Transfer"),
    //   formatter: (cell, row) => {
    //     if(row.remarks !== "Transferred from Central Store")
    //     return (
    //       <span className="text-info">
    //         <i
    //           className="bx bx-transfer font-size-22"
    //           title="Transfer"
    //           style={{ cursor: "pointer" }}
    //           onClick={() => {
    //             setSelectedBatch(row);
    //             setTransferModal(!transferModal);
    //           }}
    //         ></i>
    //       </span>
    //     );
    //   },
    //   sort: false,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "7%" };
    //   },
    // },
  ];
  const pagination_options = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "200",
        value: 200,
      },
      {
        text: "All",
        value: selectedItem_Transactions && selectedItem_Transactions.length,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
    hideSizePerPage: true,
    ignoreSinglePage: true,
  };

  const handleDownload = async () => {
    const fileName = "item_inventory";
    const exportType = "xls";

    let data_to_export = allItems;

    if (data_to_export) {
      var data = [];
      data_to_export.forEach(function (v) {
        data.push({
          name: v.name,
          description: v.description,
          category: v.category,
          sub_category: v.sub_category,
          centre_threshold: v.threshold + " " + v.unit_for_threshold,
          available: v.available.length > 0 ? ExportAvailableInCSVForReports(v.available) : " "
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            title={props.t("Inventory")}
            breadcrumbItem1={props.t("Items")}
            breadcrumbItem2={props.t("View Inventory")}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>{props.t("View Inventory")} </CardTitle>
                  <CardSubtitle className="mb-3">
                    {props.t("View all items in your inventory here")}
                  </CardSubtitle>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="printDiv">
                    <ToolkitProvider
                      bootstrap4
                      keyField="_id"
                      data={allItems && allItems}
                      // data={data && data}
                      columns={columns}
                      noDataIndication={props.t("No data to display.")}
                      search
                    >
                      {(props) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...props.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}></Col>
                            <Col lg={4} className="text-right">
                              {/* <button
                              className="btn-sm btn btn-info"
                              onClick={() => {
                                setAddInventoryModal(!addInventoryModal);
                              }}
                            >
                              Add Item
                            </button> */}
                            </Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            {...props.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>

                  <Modal
                    size="lg"
                    style={{
                      width: "940px",
                      maxWidth: "950px",
                    }}
                    isOpen={transactionsModal}
                    toggle={() => setTransactionsModal(!transactionsModal)}
                  >
                    <ModalHeader
                      toggle={() => setTransactionsModal(!transactionsModal)}
                    >
                      Item Name: {selectedItem && selectedItem.name}
                    </ModalHeader>
                    <ModalBody>
                      {selectedItem && (
                        <>
                          <Row>
                            <Col lg={12}>
                              <Card>
                                <CardBody>
                                  <Row>
                                    <Col lg={12}>
                                      <ToolkitProvider
                                        keyField="_id"
                                        data={
                                          selectedItem_Transactions &&
                                          selectedItem_Transactions
                                        }
                                        columns={columns_transaction}
                                      >
                                        {(props) => (
                                          <div>
                                            <BootstrapTable
                                              {...props.baseProps}
                                              pagination={paginationFactory(
                                                pagination_options
                                              )}
                                              noDataIndication="No data to display."
                                              striped
                                              hover
                                              condensed
                                            />
                                          </div>
                                        )}
                                      </ToolkitProvider>
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </>
                      )}
                    </ModalBody>
                  </Modal>

                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* add inventory modal starts */}
          <Modal
            size="lg"
            style={{
              width: "940px",
              maxWidth: "950px",
            }}
            isOpen={addInventoryModal}
            toggle={() => setAddInventoryModal(!addInventoryModal)}
          >
            <ModalHeader
              toggle={() => setAddInventoryModal(!addInventoryModal)}
            >
              Add Inventory
            </ModalHeader>
            <ModalBody>
              <AddOpeningComp
                isRefreshData={true}
                refreshData={loadItems}
                selectedItem={selectedItemToAdd}
                handleClosePopup={() =>
                  setAddInventoryModal(!addInventoryModal)
                }
              />
            </ModalBody>
          </Modal>

          {/* add inventory modal ends */}
           {/* ---Expiry Date Modal Start--- */}
           <ExpiryChangePopup
                    isOpen={dateChangeModal}
                    toggle={() => {
                      setDateChangeModal(false);
                      setSelectedRowForDateChange(null);
                    }}
                    onSubmit={handleExpiryDateChange}
                    initialDate={selectedRowForDateChange?.expiry_date}
                    title="Update Expiry Date"
                  />
                  {/* ---Expiry Date Modal End--- */}
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => { };
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(ViewInventory))
);
